<template>
    <div class="max-container row">
        <div class="col-12">
            <BreadcrumbComponent />
        </div>
        <router-view></router-view>
    </div>
</template>

<script lang="js">
import BreadcrumbComponent from '../components/BreadcrumbComponent'

export default {
    name: 'ReturnOrderComponent',
    components: {
        BreadcrumbComponent
    }
}
</script>